import SpriteSymbol from "../../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cloud",
  "use": "cloud-usage",
  "viewBox": "0 0 32 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 24\" id=\"cloud\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M23 22H9A7 7 0 019 8h.1A7 7 0 0116 2a6.9 6.9 0 016.7 5 7.5 7.5 0 01.3 15m1.1-17A9 9 0 007.5 6 9.1 9.1 0 000 15a9 9 0 009 9h14a9.5 9.5 0 001.1-19\" data-name=\"ab2e5896-d1c7-47c5-af04-4ac482a776f5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol